export default {
  global: {
    sideBorders: 8,
    tabSetHeaderHeight: 26,
    tabSetTabStripHeight: 26,
    enableEdgeDock: false,
    borderBarSize: 0,
  },
  // borders: [
  //   {
  //     type: 'border',
  //     location: 'bottom',
  //     children: [],
  //   },
  // ],
  layout: {
    type: 'tabset',
    weight: 100,
    id: 'root',
    children: [],
  },
};
